export default __webpack_public_path__ + "3eb46c024752a66b38516e0f282b95af.svg";